var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('message-modal'),_c('div',[_c('main-header'),_c('parcel-filter',{attrs:{"filter-name":"report"}}),_c('report-detail-header'),(!_vm.isLoading)?_c('report-detail-table'):_vm._e()],1),(_vm.isLoading)?_c('div',{staticClass:"spl-load-img"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }